import { Button } from '@/components/ui/button';
import { ArrowRight, Calculator } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Hero = () => {
  return (
    <section
      className="relative min-h-[600px] lg:min-h-[700px] flex items-center"
      data-testid="hero-section"
    >
      {/* Background Image with Overlay */}
      <div
        className="absolute inset-0 z-0"
        style={
{
          backgroundImage: 'url(https://images.unsplash.com/photo-1677253200111-97d0d490d60e?auto=compress&cs=tinysrgb&w=1920)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A1628]/95 via-[#0F2744]/90 to-[#0A1628]/80"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-[1fr_auto] gap-12 items-center">
          <div className="max-w-3xl">
            {/* Gold Accent Bar */}
            <div className="w-20 h-1 bg-gradient-to-r from-[#D4A853] to-[#F0C870] mb-6"></div>
            
            <h1
              className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-white"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              Ihr Makler für
              <span className="block mt-2">
                <span className="bg-gradient-to-r from-[#D4A853] to-[#F0C870] bg-clip-text text-transparent">
                  Handelsimmobilien
                </span>
              </span>
              <span className="block mt-2">in Deutschland</span>
            </h1>
            
            <p className="text-lg md:text-xl mb-8 leading-relaxed text-gray-100">
              Von Supermarkt bis Fachmarktzentrum – wir begleiten Eigentümer beim
              erfolgreichen Verkauf bundesweit. Mit strukturiertem Prozess und
              Spezialfokus auf Handelsimmobilien.
            </p>
            
            {/* Andreas Personal Intro */}
            <div className="flex items-center gap-4 mb-8 p-4 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20">
              <img 
                src="https://customer-assets.emergentagent.com/job_commprop-advisor/artifacts/zb797gk8_Andreas%20Heinrichs%20Hochkant%20Webseite.png" 
                alt="Andreas Heinrichs, Geschäftsführer und Spezialist für Handelsimmobilien in Deutschland"
                className="w-16 h-16 rounded-full object-cover ring-2 ring-[#D4A853]"
              />
              <div>
                <p className="text-white font-semibold text-base">Hi, ich bin Andreas Heinrichs</p>
                <p className="text-gray-300 text-sm">Spezialist für Einzelhandelsimmobilien seit 2015</p>
              </div>
            </div>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/tools/marktpreis">
              <Button
                size="lg"
                data-testid="hero-primary-cta"
                className="font-medium px-8 py-6 text-base btn-gold-gradient text-white border-0 shadow-lg hover:shadow-xl"
              >
                <Calculator className="mr-2 h-5 w-5" />
                Marktwert berechnen (60 Sek.)
              </Button>
            </Link>
            <Link to="/ersteinschaetzung">
              <Button
                size="lg"
                variant="outline"
                data-testid="hero-secondary-cta"
                className="font-semibold px-8 py-6 text-base bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white hover:bg-white/20"
              >
                Kostenlose Ersteinschätzung
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>
        
        {/* Andreas Large Profile Image - Desktop Only */}
        <div className="hidden lg:block">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-[#D4A853]/20 to-[#F0C870]/20 rounded-2xl blur-2xl"></div>
            <img 
              src="https://customer-assets.emergentagent.com/job_commprop-advisor/artifacts/zb797gk8_Andreas%20Heinrichs%20Hochkant%20Webseite.png" 
              alt="Andreas Heinrichs, Ihr Ansprechpartner für Handelsimmobilien"
              className="relative w-80 h-auto rounded-2xl shadow-2xl ring-4 ring-white/20"
            />
          </div>
        </div>
        </div>
      </div>

      {/* Floating Stats Card */}
      <div
        className="hidden lg:block absolute bottom-8 right-8 z-10"
      >
        <div className="glass-card p-6 rounded-xl">
          <div className="text-sm font-semibold text-gray-600 mb-1">Aktiv tätig</div>
          <div className="text-3xl font-bold" style={{ color: 'var(--navy-700)' }}>
            Bundesweit
          </div>
          <div className="text-sm" style={{ color: 'var(--gold-600)' }}>Deutschland</div>
        </div>
      </div>
    </section>
  );
};